import { Field, useFormikContext } from "formik";
import React, { useEffect, useRef, useState } from "react";
import "./sales.css";
import AddButton from "../buttons/button";
import CheckBox from "../forms/check-box-field";
import TextAreaField from "../forms/textarea-field";
import { ChevronUp, ChevronDown } from "lucide-react";
import ItemsInputField from "../forms/items-input-field";
import errorToast from "../helper-components/error-toast";

const PaymentInOutFooter = ({
  page = "add",
  clearDue,
  section = "pit",
  disabled = false,
  checkedId,
  submitLoading,
  setPaymentMeans,
}) => {
  const { values, setFieldValue, submitForm } = useFormikContext();
  const [isOpen, setIsOpen] = useState(false);
  const [save, setSave] = useState(false);

  const prefix = section === "pit" ? "soit" : "poit";

  useEffect(() => {
    if (checkedId.length > 0 && values?.[`${section}_current_payment`] <= 0) {
      setSave(true);
    } else setSave(false);
  }, []);

  useEffect(() => {
    if (checkedId.length > 0 && values?.[`${section}_current_payment`] <= 0) {
      setSave(true);
    } else setSave(false);
  }, [checkedId.length, values?.[`${section}_current_payment`]]);

  //css variables
  const lableClass =
    "leading-5  text-[length:var(--footer-input-lable-font-size)] font-[var(--footer-input-lable-font-weight)]";

  return (
    <div className=" mx-0 px-0">
      <div className=" w-full  flex space-x-0 shadow-[0_-15px_15px_-5px_rgba(0,0,0,0.03)_inset] ">
        <div className="h-[103px] flex-1 justify-between border-[var(--light-border-color)] border-[1.1px]  px-[15px] py-[16px] flex  flex-col">
          {/* <ItemsInputField
            inputClass="text-[length:var(--create-table-footer-totals-fs)] font-normal p-3  rounded-lg  border border-[var(--items-search-input-border)] focus:outline-none 
            focus:border-[var(--items-search-input-focus)] bg-[var(--items-search-input-bg)]"
            labelClass="leading-5 text-secondary text-sm fw_400"
            isDisabled={disabled}
            type="text"
            name="payment_journal_remarks"
            label="Journal Remarks"
            isLabelReq="true"
            id={"payment_journal_remarks"}
            placeholder="journal remarks here"
            disabled={disabled}
          /> */}
          <label className={lableClass}>Journal Remarks</label>
          <input
            label="Journal Remarks"
            name="payment_journal_remarks"
            id={"payment_journal_remarks"}
            isRequired={false}
            placeholder="journal remarks here"
            disabled={disabled}
            className="text-[length:var(--create-table-footer-totals-fs)] font-normal p-3  rounded-lg  border border-[var(--items-search-input-border)] focus:outline-none 
      focus:border-[var(--items-search-input-focus)] bg-[var(--items-search-input-bg)]"
            type="text"
          />
        </div>

        <div className="h-[103px] flex-1 flex flex-col justify-between  border-[var(--create-table-footer-border)] border-t-[1.1px] border-b-[1.1px]    px-[15px] py-[16px]">
          <div>
            <input
              disabled={true}
              checked={
                page === "Edit" || page === "view"
                  ? values?.[`${section}_add_to_account_amount`] > 0
                  : false
              }
              style={{ transform: "scale(1.4)" }}
              type="checkbox"
              id="myCheckbox"
              className="custom-checkbox form-check-input ml-[3px]"
            />
            <label className={`leading-5 ${lableClass} pl-3`}>
              Payment On Account
            </label>
          </div>
          <div>
            <input
              disabled={true}
              value={parseFloat(
                values?.[`${section}_add_to_account_amount`]
              ).toFixed(2)}
              className="text-[length:var(--create-table-footer-totals-fs)] font-normal w-full  p-3  rounded-lg  border border-[var(--items-search-input-border)] focus:outline-none 
      focus:border-[var(--items-search-input-focus)] bg-[var(--items-search-input-bg)]"
              type="number"
            />
          </div>
        </div>
        <div className="h-[103px] flex-1 justify-between border-[var(--light-border-color)] border-[1.1px]   px-[15px] py-[16px] flex flex-col">
          <label className={lableClass}>Open Balance</label>
          <input
            disabled={true}
            className={`text-[length:var(--create-table-footer-totals-fs)]   p-3  rounded-lg  border border-[var(--items-search-input-border)] focus:outline-none 
      focus:border-[var(--items-search-input-focus)] bg-[var(--items-search-input-bg)]  `}
            type="text"
            value={
              parseFloat(values?.[`${section}_open_balance`]).toFixed(2) ?? 0
            }
          />
        </div>

        <div
          className=" w-[331px] flex-none justify-between  px-5 h-full flex flex-col items-center  mt-auto
    bg-[var(--create-table-footer-totals-bg)] text-[var(--create-table-footer-totals-fg)]
    text-[length:var(--create-table-footer-totals-fs)] font-[var(--create-table-footer-totals-fw)] relative"
        >
          {/* Toggle Button */}
          {!isOpen && (
            <div
              className="absolute top-[-1.2rem] left-1/2 transform -translate-x-1/2 bg-[var(--create-table-footer-totals-bg)] cursor-pointer 
                  flex items-start justify-center"
              style={{
                width: "80px",
                height: "55px",
                borderRadius: "999999px", // makes it oval
                padding: "0.2rem",
              }}
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
            </div>
          )}
          {/* Sliding Details */}
          {isOpen && !clearDue && (
            <div
              className="px-[1rem] py-[1.125rem] flex flex-col w-full space-y-[12px] absolute bottom-[100%]"
              style={{
                backgroundColor: "var(--create-tab-foot-subTot-bg)",
                color: "var(--create-tab-foot-subTot-fg)",
                fontSize: "var(--create-tab-foot-subTot-fs)",
                fontWeight: "var(--create-tab-foot-subTot-fw)",
              }}
            >
              <div className="leading-[26.4px] flex justify-between ">
                <span>Invoice Total</span>
                {console.log(
                  values.invoices,
                  values?.[`${section}_total_amount`]
                )}
                <span>
                  {" "}
                  ₹ {parseFloat(values?.[`${section}_total_amount`]).toFixed(2)}
                </span>
              </div>
              <div className="leading-[26.4px] flex justify-between ">
                <span>Credit Note Amount</span>
                <span style={{ color: "var(--success-color)" }}>
                  ₹ {parseFloat(values?.credit_note_amount).toFixed(2)}
                </span>
              </div>
              <div className="leading-[26.4px] flex justify-between ">
                <span>Journal Entry</span>
                <span style={{ color: "var(--success-color)" }}>
                  ₹ {parseFloat(values?.journal_entry).toFixed(2)}
                </span>
              </div>
              {/* <div className="leading-[26.4px] flex justify-between ">
                <span>Open Balance</span>
                <span
                  className={
                    values?.[`${section}_open_balance`] > 0
                      ? "text-[var(--success-color)]"
                      : values?.[`${section}_open_balance`] < 0
                      ? "text-[var(--error-color)]"
                      : ""
                  }
                >
                  {parseFloat(values?.[`${section}_open_balance`]).toFixed(2) >
                  0
                    ? "-"
                    : null}{" "}
                  ₹ {parseFloat(values?.[`${section}_open_balance`]).toFixed(2)}
                </span>
              </div> */}
              <div className=" leading-[26.4px] flex justify-between ">
                <span>Total Due Amount</span>
                <span>
                  ₹{" "}
                  {(
                    parseFloat(values?.[`${section}_total_amount`]) +
                    // -
                    // parseFloat(values?.[`${section}_open_balance`])
                    parseFloat(values?.credit_note_amount ?? 0)
                  ).toFixed(2)}
                </span>
              </div>
              <div className="leading-[26.4px] flex justify-between ">
                <span>Balance</span>
                <span className={parseFloat(values?.balanceAmt || 0) > 0}>
                  ₹{" "}
                  {values?.balanceAmt.toFixed(2) > 0
                    ? values?.balanceAmt.toFixed(2)
                    : "0.00"}
                </span>
              </div>

              <div
                className={`absolute top-[-2.3rem] left-1/2 transform -translate-x-1/2 bg-[var(--create-tab-foot-subTot-bg)] cursor-pointer 
            flex items-start justify-center `}
                style={{
                  width: "80px",
                  height: "55px",
                  borderRadius: "9999px", // makes it oval
                  padding: "0.2rem",
                }}
                onClick={() => setIsOpen(!isOpen)}
              >
                {isOpen ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
              </div>
            </div>
          )}

          {/* Total Amount */}
          <div className=" leading-[26.4px] flex justify-between w-full  py-[24.3px] mt-auto  h-full items-center z-10">
            <span>Current Payment </span>
            <span>
              {console.error(parseFloat(values?.[`${section}_current_payment`]) )}
              ₹{" "}
              {
              // clearDue
              //   ? values.clearDueInput
              //   : checkedId.length > 0
                // ? 
                (
                    parseFloat(values?.[`${section}_current_payment`]) 
                    // +
                    // parseFloat(values?.journal_entry) +
                    // parseFloat(values?.credit_note_amount)
                  ).toFixed(2)

                // : "0.00"
                }
            </span>
          </div>
        </div>
      </div>
      <div className="h-[4rem] flex justify-between px-5">
        <div></div>
        <div className="flex gap-3 items-center">
          {!disabled && (
            <AddButton
              prefixIcon={false}
              text={"Draft"}
              className="
    flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--draft-button-bg)] cursor-pointer
    text-[var(--draft-button-fg)]
    border border-[var(--draft-button-border)]
    text-[length:var(--draft-button-fs)] 
    font-[var(--draft-button-fw)]
    "
              type="button"
              onclkFn={() => {
                console.log(":::::::::::::::::: clicked ::::::::::::::::::::");
                if (submitLoading === false) {
                  if (values.invoices.length > 0) {
                    if (checkedId.length > 0) {
                      setFieldValue("submittedButton", "draft");
                      submitForm();
                    }
                  } else errorToast("Select Invoice");
                } else errorToast("Search for Invoice");
              }}
            />
          )}
          <AddButton
            prefixIcon={false}
            // isDisabled={
            //   (disabled && !save) ||
            //   (!disabled &&
            //     !((clearDue && values?.clearDueInput === 0) || !save))  // (false && false) || (true && true)
            // }
            isDisabled={
              disabled === false
                ? false
                  ? save === true
                    ? false
                    : false
                  : false
                : true
            }
            text={
              disabled
                ? save
                  ? "Saved"
                  : "View Payment Method"
                : save
                ? "Save"
                : "Add Payment Method"
            }
            className="
    flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)] 
    font-[var(--primary-button-font-weight)]
    "
            type="button"
            onclkFn={() => {
              if (!clearDue) {
                if (values.invoices.length > 0) {
                  if (checkedId.length > 0) {
                    if (values?.[`${section}_current_payment`] > 0) {
                      setPaymentMeans(true);
                    } else {
                      submitForm();
                    }
                  } else errorToast("Select Invoice");
                } else errorToast("Search for Invoice");
              } else {
                setPaymentMeans(true);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentInOutFooter;
//
